/*
Licensed Materials - Property of IBM
694906H
(c) Copyright IBM Corp.  2020 All Rights Reserved

US Government Users Restricted Rights - Use, duplication or disclosure restricted
by GSA ADP Schedule Contract with IBM Corp.
*/

import React from 'react';
import { useIntl } from '@exo/frontend-common-i18n';
import { Grid, Row, Column } from '@exo/frontend-components-base';

import { ResetPasswordContainer } from '@exo/frontend-features-insurance-polaris-login-logic';
import { ResetPassword } from '../../components/ResetPassword/ResetPassword';
import * as S from './ResetPasswordPage.styles';
import { TopTitle } from '../../components/TopTitle/TopTitle';
import { AuthEndpointsConfig } from '../../authConfig';

export const ResetPasswordPage = ({authConfig}: Props) => {
  const intl = useIntl('features.polaris-login.polaris-login-ui.pages.ResetPasswordPage');
  const endpoints = {
    securityQuestions: authConfig?.securityQuestions,
    requestAuthCode: authConfig?.requestAuthCode
  }
  return (
    <S.ResetPasswordPage>
      <S.Container>
        <TopTitle
          title={intl.msg('page.top.title', 'Step 1') as string}
          subtitle={intl.msg('page.top.subtitle', 'Request Authorisation Code') as string}
        />
        <S.Title>{intl.msg('page.title', 'Request Authorisation Code Confirmation')}</S.Title>
        <Grid isFluid>
          <Row>
            <Column>
              <ResetPasswordContainer endpoints={endpoints} render={args => <ResetPassword {...args} />} />
            </Column>
          </Row>
        </Grid>
      </S.Container>
    </S.ResetPasswordPage>
  );
};

type Props = {
  authConfig: AuthEndpointsConfig;
};
